<script lang="ts">
	import type { FighterAttributes } from '../types';
	export let blue: FighterAttributes;
	export let red: FighterAttributes;
</script>

<div class="d-flex w-100 justify-content-between image-column">
	<div class="definitions d-none d-sm-block">
		<dt class="w-100 border-0" />
	</div>
	<div class="column blue-column">
		<dd class="border-0 imgwrap">
			<img class="img-fluid" src={blue.imageUrl} alt="" />
		</dd>
	</div>
	<div class="column red-column">
		<dd class=" border-0 imgwrap">
			<img class="img-fluid" src={red.imageUrl} alt="" />
		</dd>
	</div>
</div>

<div class="d-flex w-100 justify-content-between mb-4">
	<div class="definitions d-none d-sm-block">
		<dt class="top-definition"><h5>Name</h5></dt>
		<dt>BKF Record</dt>
		<dt>Height</dt>
		<dt>Weight</dt>
		<dt>Age</dt>
		<!-- <dt>Fist Size</dt> -->
		<!-- <dt>Reach</dt> -->
		<dt>Nationality</dt>
	</div>

	<div class="column blue-column">
		<dd>
			<h5>{blue.displayName}</h5>
		</dd>
		<dd>{blue.professionalRecords.bkfc}</dd>
		<dd>{blue.height}</dd>
		<dd>{blue.weight} lbs</dd>
		<dd>{blue.age}</dd>
		<!-- <dd>{blue.fistSize}</dd> -->
		<!-- <dd>{blue.reach}</dd> -->
		<dd>{blue.nationality}</dd>
	</div>

	<div class="column red-column">
		<dd class="border-0">
			<h5>{red.displayName}</h5>
		</dd>
		<dd>{red.professionalRecords.bkfc}</dd>

		<dd>{red.height}</dd>
		<dd>{red.weight} lbs</dd>
		<dd>{red.age}</dd>
		<!-- <dd>{red.fistSize}</dd> -->
		<!-- <dd>{red.reach}</dd> -->
		<dd>{red.nationality}</dd>
	</div>
</div>

<style>
	.blue-column img,
	.red-column img {
		border-radius: 10px 10px 0 0;
	}
	.blue-column img {
		border-bottom: 1em solid blue;
	}
	.red-column img {
		border-bottom: 1em solid red;
	}

	.column {
		background-color: #ffffff;
		width: 37%;
	}

	.red-column {
		margin-left: 5%;
	}

	.definitions {
		width: 20%;
	}

	dd,
	dt {
		border-top: 1px dotted #ccc;
		padding: 3px;
	}

	dt {
		margin-bottom: 0.5rem;
		padding: 3px;
	}

	.top-definition {
		border: 0;
	}

	@media (max-width: 576px) {
		.column,
		.column {
			width: 50%;
		}
	}
</style>
